import { render, staticRenderFns } from "./PriceEditorView.vue?vue&type=template&id=5f270c33&scoped=true"
import script from "./PriceEditorView.vue?vue&type=script&lang=js"
export * from "./PriceEditorView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f270c33",
  null
  
)

export default component.exports